module.exports = __webpack_public_path__ + "static/media/industria-3.bb183536.jpg";